import ReactQrCode from 'qrcode.react';

type QrCodeProps = React.ComponentProps<typeof ReactQrCode>;

const QRCode = (props: QrCodeProps) => {
  return <ReactQrCode {...props} />;
};

export { QRCode };
